module.exports = __webpack_public_path__ + "files/134778dc3a3891264249e01dc41d0ca7.png";